import wip from './wip'
import getBodySettings from "../global/page-settings";

const { nameArea, nameController, nameAction, namePage } = getBodySettings('page');

export default function(){
    if(nameController === 'wip') wip();
}